import { render, staticRenderFns } from "./PurchaseInvoiceCount.vue?vue&type=template&id=d05a1d6e&scoped=true"
import script from "./PurchaseInvoiceCount.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceCount.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoiceCount.vue?vue&type=style&index=0&id=d05a1d6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05a1d6e",
  null
  
)

export default component.exports